import { Action, ACTION_TYPE } from '@abiglobalhealth/go-types'

import { actionsRequest } from './utils'

export const trackEvent = async <T extends Action<ACTION_TYPE.TRACK_EVENT>>(payload: T['payload'], signal?: AbortSignal): Promise<T['response']> => {
  const body = await actionsRequest<T>(
    {
      payload,
      type: ACTION_TYPE.TRACK_EVENT
    },
    signal
  )
  return body.data
}
